import { NetworkConfiguration } from "../../network/networkConfriguation";
import { callAPI } from "../../network/networkConnection";

const getProductSubscription = (queryParams) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.SUBSCRIBED_PRODUCTS +
        queryParams,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const addExcelProductUnsubscription = (formData) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.EXCEL_UNSUBSCRIBED_PRODUCTS,
      "POST",
      {},
      formData
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const addExcelProductSubscription = (formData) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.EXCEL_SUBSCRIBED_PRODUCTS,
      "POST",
      {},
      formData
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const unsubscribeProducts = (productsPayload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.MULTIPLE_PRODUCTS_UNSUBSCRIBE,
      "POST",
      {
        "Content-Type": "application/json",
      },
      productsPayload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const exportSubscribeProduct = (productPayload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.EXPORT_SUBSCRIBE_PRODUCT,
      "POST",
      {
        "Content-Type": "application/json",
      },
      productPayload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const exportAmazonProduct = (productPayload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem("LOGIN_HEADER");
      const response = await fetch(
        process.env.REACT_APP_APIUrl +
          NetworkConfiguration.EXPORT_AMAZON_TEMPLATE,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: productPayload,
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        reject(new Error(errorData?.error?.message || "Export failed"));
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "AmazonTemplate.zip");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      resolve({ status: { code: 200 }, data: { directDownload: true } });
    } catch (err) {
      reject(err);
    }
  });
};

const exportSubscribeProductInImage = (productPayload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.EXPORT_SUBSCRIBE_PRODUCT_IN_IMAGE,
      "POST",
      {
        "Content-Type": "application/json",
      },
      productPayload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const syncAllProducts = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.SYNC_ALL_PRODUCTS,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// UPDATED: syncSelectedProducts now posts `products: [{parentSku, variants[], areSynced}]`
const syncSelectedProducts = (productPayload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.SYNC_SELECTED_PRODUCTS,
      "POST",
      {
        "Content-Type": "application/json",
      },
      productPayload
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getUnmappedProducts = (queryParams) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + "product/my/unmapped" + queryParams,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getUnmappedCount = () => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + "product/my/unmapped/count",
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const mapProductCategory = (productId, categoryId) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + `product/my/map-category/${productId}`,
      "PUT",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify({ categoryId })
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getSearchKeywords = (productId = null) => {
  return new Promise((resolve, reject) => {
    const queryParam = productId ? `?productId=${productId}` : "";
    callAPI(
      process.env.REACT_APP_APIUrl + "product/my/search-keywords" + queryParam,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const getProductsBySearchKeyword = (searchKey) => {
  return new Promise((resolve, reject) => {
    const queryParam = searchKey ? `?searchKey=${encodeURIComponent(searchKey)}` : "";
    callAPI(
      process.env.REACT_APP_APIUrl + "product/my/search-keyword-products" + queryParam,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// NEW: fetch single product variants for a parent SKU
const getProductVariants = (productId, by = "id") => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
        NetworkConfiguration.GET_PRODUCT_VARIANTS +
        `/${productId}?by=${by}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then(res => resolve(res))
      .catch(err => reject(err));
  });
};

export const ProductSubscriptionApiService = {
  getProductSubscription,
  addExcelProductUnsubscription,
  addExcelProductSubscription,
  unsubscribeProducts,
  exportSubscribeProduct,
  exportSubscribeProductInImage,
  syncAllProducts,
  syncSelectedProducts,
  exportAmazonProduct,
  getUnmappedProducts,
  getUnmappedCount,
  mapProductCategory,
  getSearchKeywords,
  getProductVariants,
  getProductsBySearchKeyword,
};
